import { useContext } from 'react';

import TaskDrawerContext from './TaskDrawerContext';

export default function useTaskDrawer() {
  const context = useContext(TaskDrawerContext);

  return context;
}
